import { graphql } from '@eluve/graphql.tada';

export const getFullAuditTrailQuery = graphql(`
  query getFullAuditTrail {
    auditTrail(orderBy: { createdAt: DESC_NULLS_LAST }) {
      __typename
      id
      createdAt
      operation
      data
      tableName
      user {
        __typename
        id
        firstName
        lastName
        email
      }
    }
  }
`);
